var _style, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineaVida1080(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 150",
    style: {
      enableBackground: "new 0 0 1080 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1080.2,94.8 1068.3,94.8 1068.3,94.8 669.1,94.7 665.3,105 658,124.8 615,7.9 612.2,0.5 606.8,0.5  604,7.9 572,94.7 543.6,94.7 539.8,105 531,129 522.2,105 518.4,94.7 504.7,57.5 501.9,50 496.4,50 493.7,57.5 479.9,94.7  423.4,94.7 394.3,94.7 168.3,94.7 168.3,94.7 106.6,94.7 106.6,94.7 20.8,94.7 20.8,94.7 -0.1,94.7 -0.1,105 11.5,105 11.5,105  103.2,105 168.3,105 394.3,105 423.4,105 487.1,105 490.9,94.7 499.2,72.4 507.4,94.7 511.2,105 525.5,143.8 527.9,150.3  534.1,150.3 536.4,143.8 550.7,105 579.2,105 583,94.7 609.5,22.8 652.5,139.7 655,146.4 661.1,146.4 663.4,139.7 676.3,105  1068.5,105 1068.5,105 1080.2,105 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaVida1080);
export default __webpack_public_path__ + "static/media/LINEA-VIDA-1080.52ddb65df22d7a07e3d77f186c71472d.svg";
export { ForwardRef as ReactComponent };